<template>
  <div id="app">
    <router-view/>
  </div>
</template>
<script>
	export default ({
		created() {
      		window.document.title = "BI数据后台";
		}
	})
	
</script>
<style>
body {
  margin: 0;
  padding: 0;
  height: 100vh;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  background-color: #f8f9fa;
  height: 100vh;
}

/* nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
} */


.ml1 { margin-left: 1px; }
.ml2 { margin-left: 2px; }
.ml3 { margin-left: 3px; }
.ml4 { margin-left: 4px; }
.ml5 { margin-left: 5px; }
.ml6 { margin-left: 6px; }
.ml7 { margin-left: 7px; }
.ml8 { margin-left: 8px; }
.ml9 { margin-left: 9px; }
.ml10 { margin-left: 10px; }
.ml11 { margin-left: 11px; }
.ml12 { margin-left: 12px; }
.ml13 { margin-left: 13px; }
.ml14 { margin-left: 14px; }
.ml15 { margin-left: 15px; }
.ml16 { margin-left: 16px; }
.ml17 { margin-left: 17px; }
.ml18 { margin-left: 18px; }
.ml19 { margin-left: 19px; }
.ml20 { margin-left: 20px; }
.ml21 { margin-left: 21px; }
.ml22 { margin-left: 22px; }
.ml23 { margin-left: 23px; }
.ml24 { margin-left: 24px; }
.ml25 { margin-left: 25px; }
.ml26 { margin-left: 26px; }
.ml27 { margin-left: 27px; }
.ml28 { margin-left: 28px; }
.ml29 { margin-left: 29px; }
.ml30 { margin-left: 30px; }
.ml31 { margin-left: 31px; }
.ml32 { margin-left: 32px; }
.ml33 { margin-left: 33px; }
.ml34 { margin-left: 34px; }
.ml35 { margin-left: 35px; }
.ml36 { margin-left: 36px; }
.ml37 { margin-left: 37px; }
.ml38 { margin-left: 38px; }
.ml39 { margin-left: 39px; }
.ml40 { margin-left: 40px; }
.mt1 { margin-top: 1px; }
.mt2 { margin-top: 2px; }
.mt3 { margin-top: 3px; }
.mt4 { margin-top: 4px; }
.mt5 { margin-top: 5px; }
.mt6 { margin-top: 6px; }
.mt7 { margin-top: 7px; }
.mt8 { margin-top: 8px; }
.mt9 { margin-top: 9px; }
.mt10 { margin-top: 10px; }
.mt11 { margin-top: 11px; }
.mt12 { margin-top: 12px; }
.mt13 { margin-top: 13px; }
.mt14 { margin-top: 14px; }
.mt15 { margin-top: 15px; }
.mt16 { margin-top: 16px; }
.mt17 { margin-top: 17px; }
.mt18 { margin-top: 18px; }
.mt19 { margin-top: 19px; }
.mt20 { margin-top: 20px; }
.mt21 { margin-top: 21px; }
.mt22 { margin-top: 22px; }
.mt23 { margin-top: 23px; }
.mt24 { margin-top: 24px; }
.mt25 { margin-top: 25px; }
.mt26 { margin-top: 26px; }
.mt27 { margin-top: 27px; }
.mt28 { margin-top: 28px; }
.mt29 { margin-top: 29px; }
.mt30 { margin-top: 30px; }
.mt31 { margin-top: 31px; }
.mt32 { margin-top: 32px; }
.mt33 { margin-top: 33px; }
.mt34 { margin-top: 34px; }
.mt35 { margin-top: 35px; }
.mt36 { margin-top: 36px; }
.mt37 { margin-top: 37px; }
.mt38 { margin-top: 38px; }
.mt39 { margin-top: 39px; }
.mt40 { margin-top: 40px; }
.mr1 { margin-right: 1px; }
.mr2 { margin-right: 2px; }
.mr3 { margin-right: 3px; }
.mr4 { margin-right: 4px; }
.mr5 { margin-right: 5px; }
.mr6 { margin-right: 6px; }
.mr7 { margin-right: 7px; }
.mr8 { margin-right: 8px; }
.mr9 { margin-right: 9px; }
.mr10 { margin-right: 10px; }
.mr11 { margin-right: 11px; }
.mr12 { margin-right: 12px; }
.mr13 { margin-right: 13px; }
.mr14 { margin-right: 14px; }
.mr15 { margin-right: 15px; }
.mr16 { margin-right: 16px; }
.mr17 { margin-right: 17px; }
.mr18 { margin-right: 18px; }
.mr19 { margin-right: 19px; }
.mr20 { margin-right: 20px; }
.mr21 { margin-right: 21px; }
.mr22 { margin-right: 22px; }
.mr23 { margin-right: 23px; }
.mr24 { margin-right: 24px; }
.mr25 { margin-right: 25px; }
.mr26 { margin-right: 26px; }
.mr27 { margin-right: 27px; }
.mr28 { margin-right: 28px; }
.mr29 { margin-right: 29px; }
.mr30 { margin-right: 30px; }
.mr31 { margin-right: 31px; }
.mr32 { margin-right: 32px; }
.mr33 { margin-right: 33px; }
.mr34 { margin-right: 34px; }
.mr35 { margin-right: 35px; }
.mr36 { margin-right: 36px; }
.mr37 { margin-right: 37px; }
.mr38 { margin-right: 38px; }
.mr39 { margin-right: 39px; }
.mr40 { margin-right: 40px; }
.mb1 { margin-bottom: 1px; }
.mb2 { margin-bottom: 2px; }
.mb3 { margin-bottom: 3px; }
.mb4 { margin-bottom: 4px; }
.mb5 { margin-bottom: 5px; }
.mb6 { margin-bottom: 6px; }
.mb7 { margin-bottom: 7px; }
.mb8 { margin-bottom: 8px; }
.mb9 { margin-bottom: 9px; }
.mb10 { margin-bottom: 10px; }
.mb11 { margin-bottom: 11px; }
.mb12 { margin-bottom: 12px; }
.mb13 { margin-bottom: 13px; }
.mb14 { margin-bottom: 14px; }
.mb15 { margin-bottom: 15px; }
.mb16 { margin-bottom: 16px; }
.mb17 { margin-bottom: 17px; }
.mb18 { margin-bottom: 18px; }
.mb19 { margin-bottom: 19px; }
.mb20 { margin-bottom: 20px; }
.mb21 { margin-bottom: 21px; }
.mb22 { margin-bottom: 22px; }
.mb23 { margin-bottom: 23px; }
.mb24 { margin-bottom: 24px; }
.mb25 { margin-bottom: 25px; }
.mb26 { margin-bottom: 26px; }
.mb27 { margin-bottom: 27px; }
.mb28 { margin-bottom: 28px; }
.mb29 { margin-bottom: 29px; }
.mb30 { margin-bottom: 30px; }
.mb31 { margin-bottom: 31px; }
.mb32 { margin-bottom: 32px; }
.mb33 { margin-bottom: 33px; }
.mb34 { margin-bottom: 34px; }
.mb35 { margin-bottom: 35px; }
.mb36 { margin-bottom: 36px; }
.mb37 { margin-bottom: 37px; }
.mb38 { margin-bottom: 38px; }
.mb39 { margin-bottom: 39px; }
.mb40 { margin-bottom: 40px; }
.pl1 { padding-left: 1px; }
.pl2 { padding-left: 2px; }
.pl3 { padding-left: 3px; }
.pl4 { padding-left: 4px; }
.pl5 { padding-left: 5px; }
.pl6 { padding-left: 6px; }
.pl7 { padding-left: 7px; }
.pl8 { padding-left: 8px; }
.pl9 { padding-left: 9px; }
.pl10 { padding-left: 10px; }
.pl11 { padding-left: 11px; }
.pl12 { padding-left: 12px; }
.pl13 { padding-left: 13px; }
.pl14 { padding-left: 14px; }
.pl15 { padding-left: 15px; }
.pl16 { padding-left: 16px; }
.pl17 { padding-left: 17px; }
.pl18 { padding-left: 18px; }
.pl19 { padding-left: 19px; }
.pl20 { padding-left: 20px; }
.pl21 { padding-left: 21px; }
.pl22 { padding-left: 22px; }
.pl23 { padding-left: 23px; }
.pl24 { padding-left: 24px; }
.pl25 { padding-left: 25px; }
.pl26 { padding-left: 26px; }
.pl27 { padding-left: 27px; }
.pl28 { padding-left: 28px; }
.pl29 { padding-left: 29px; }
.pl30 { padding-left: 30px; }
.pl31 { padding-left: 31px; }
.pl32 { padding-left: 32px; }
.pl33 { padding-left: 33px; }
.pl34 { padding-left: 34px; }
.pl35 { padding-left: 35px; }
.pl36 { padding-left: 36px; }
.pl37 { padding-left: 37px; }
.pl38 { padding-left: 38px; }
.pl39 { padding-left: 39px; }
.pl40 { padding-left: 40px; }
.pt1 { padding-top: 1px; }
.pt2 { padding-top: 2px; }
.pt3 { padding-top: 3px; }
.pt4 { padding-top: 4px; }
.pt5 { padding-top: 5px; }
.pt6 { padding-top: 6px; }
.pt7 { padding-top: 7px; }
.pt8 { padding-top: 8px; }
.pt9 { padding-top: 9px; }
.pt10 { padding-top: 10px; }
.pt11 { padding-top: 11px; }
.pt12 { padding-top: 12px; }
.pt13 { padding-top: 13px; }
.pt14 { padding-top: 14px; }
.pt15 { padding-top: 15px; }
.pt16 { padding-top: 16px; }
.pt17 { padding-top: 17px; }
.pt18 { padding-top: 18px; }
.pt19 { padding-top: 19px; }
.pt20 { padding-top: 20px; }
.pt21 { padding-top: 21px; }
.pt22 { padding-top: 22px; }
.pt23 { padding-top: 23px; }
.pt24 { padding-top: 24px; }
.pt25 { padding-top: 25px; }
.pt26 { padding-top: 26px; }
.pt27 { padding-top: 27px; }
.pt28 { padding-top: 28px; }
.pt29 { padding-top: 29px; }
.pt30 { padding-top: 30px; }
.pt31 { padding-top: 31px; }
.pt32 { padding-top: 32px; }
.pt33 { padding-top: 33px; }
.pt34 { padding-top: 34px; }
.pt35 { padding-top: 35px; }
.pt36 { padding-top: 36px; }
.pt37 { padding-top: 37px; }
.pt38 { padding-top: 38px; }
.pt39 { padding-top: 39px; }
.pt40 { padding-top: 40px; }
.pr1 { padding-right: 1px; }
.pr2 { padding-right: 2px; }
.pr3 { padding-right: 3px; }
.pr4 { padding-right: 4px; }
.pr5 { padding-right: 5px; }
.pr6 { padding-right: 6px; }
.pr7 { padding-right: 7px; }
.pr8 { padding-right: 8px; }
.pr9 { padding-right: 9px; }
.pr10 { padding-right: 10px; }
.pr11 { padding-right: 11px; }
.pr12 { padding-right: 12px; }
.pr13 { padding-right: 13px; }
.pr14 { padding-right: 14px; }
.pr15 { padding-right: 15px; }
.pr16 { padding-right: 16px; }
.pr17 { padding-right: 17px; }
.pr18 { padding-right: 18px; }
.pr19 { padding-right: 19px; }
.pr20 { padding-right: 20px; }
.pr21 { padding-right: 21px; }
.pr22 { padding-right: 22px; }
.pr23 { padding-right: 23px; }
.pr24 { padding-right: 24px; }
.pr25 { padding-right: 25px; }
.pr26 { padding-right: 26px; }
.pr27 { padding-right: 27px; }
.pr28 { padding-right: 28px; }
.pr29 { padding-right: 29px; }
.pr30 { padding-right: 30px; }
.pr31 { padding-right: 31px; }
.pr32 { padding-right: 32px; }
.pr33 { padding-right: 33px; }
.pr34 { padding-right: 34px; }
.pr35 { padding-right: 35px; }
.pr36 { padding-right: 36px; }
.pr37 { padding-right: 37px; }
.pr38 { padding-right: 38px; }
.pr39 { padding-right: 39px; }
.pr40 { padding-right: 40px; }
.pb1 { padding-bottom: 1px; }
.pb2 { padding-bottom: 2px; }
.pb3 { padding-bottom: 3px; }
.pb4 { padding-bottom: 4px; }
.pb5 { padding-bottom: 5px; }
.pb6 { padding-bottom: 6px; }
.pb7 { padding-bottom: 7px; }
.pb8 { padding-bottom: 8px; }
.pb9 { padding-bottom: 9px; }
.pb10 { padding-bottom: 10px; }
.pb11 { padding-bottom: 11px; }
.pb12 { padding-bottom: 12px; }
.pb13 { padding-bottom: 13px; }
.pb14 { padding-bottom: 14px; }
.pb15 { padding-bottom: 15px; }
.pb16 { padding-bottom: 16px; }
.pb17 { padding-bottom: 17px; }
.pb18 { padding-bottom: 18px; }
.pb19 { padding-bottom: 19px; }
.pb20 { padding-bottom: 20px; }
.pb21 { padding-bottom: 21px; }
.pb22 { padding-bottom: 22px; }
.pb23 { padding-bottom: 23px; }
.pb24 { padding-bottom: 24px; }
.pb25 { padding-bottom: 25px; }
.pb26 { padding-bottom: 26px; }
.pb27 { padding-bottom: 27px; }
.pb28 { padding-bottom: 28px; }
.pb29 { padding-bottom: 29px; }
.pb30 { padding-bottom: 30px; }
.pb31 { padding-bottom: 31px; }
.pb32 { padding-bottom: 32px; }
.pb33 { padding-bottom: 33px; }
.pb34 { padding-bottom: 34px; }
.pb35 { padding-bottom: 35px; }
.pb36 { padding-bottom: 36px; }
.pb37 { padding-bottom: 37px; }
.pb38 { padding-bottom: 38px; }
.pb39 { padding-bottom: 39px; }
.pb40 { padding-bottom: 40px; }
.pd1 { padding: 1px; }
.pd2 { padding: 2px; }
.pd3 { padding: 3px; }
.pd4 { padding: 4px; }
.pd5 { padding: 5px; }
.pd6 { padding: 6px; }
.pd7 { padding: 7px; }
.pd8 { padding: 8px; }
.pd9 { padding: 9px; }
.pd10 { padding: 10px; }
.pd11 { padding: 11px; }
.pd12 { padding: 12px; }
.pd13 { padding: 13px; }
.pd14 { padding: 14px; }
.pd15 { padding: 15px; }
.pd16 { padding: 16px; }
.pd17 { padding: 17px; }
.pd18 { padding: 18px; }
.pd19 { padding: 19px; }
.pd20 { padding: 20px; }
.pd21 { padding: 21px; }
.pd22 { padding: 22px; }
.pd23 { padding: 23px; }
.pd24 { padding: 24px; }
.pd25 { padding: 25px; }
.pd26 { padding: 26px; }
.pd27 { padding: 27px; }
.pd28 { padding: 28px; }
.pd29 { padding: 29px; }
.pd30 { padding: 30px; }
.pd31 { padding: 31px; }
.pd32 { padding: 32px; }
.pd33 { padding: 33px; }
.pd34 { padding: 34px; }
.pd35 { padding: 35px; }
.pd36 { padding: 36px; }
.pd37 { padding: 37px; }
.pd38 { padding: 38px; }
.pd39 { padding: 39px; }
.pd40 { padding: 40px; }
.fs12 { font-size: 12px; }
.fs13 { font-size: 13px; }
.fs14 { font-size: 14px; }
.fs15 { font-size: 15px; }
.fs16 { font-size: 16px; }
.fs17 { font-size: 17px; }
.fs18 { font-size: 18px; }
.fs19 { font-size: 19px; }
.fs20 { font-size: 20px; }
.fs21 { font-size: 21px; }
.fs22 { font-size: 22px; }
.fs23 { font-size: 23px; }
.fs24 { font-size: 24px; }
.fs25 { font-size: 25px; }
.fs26 { font-size: 26px; }
.fs27 { font-size: 27px; }
.fs28 { font-size: 28px; }
.fs29 { font-size: 29px; }
.fs30 { font-size: 30px; }
.fs31 { font-size: 31px; }
.fs32 { font-size: 32px; }
.fs33 { font-size: 33px; }
.fs34 { font-size: 34px; }
.fs35 { font-size: 35px; }
.fs36 { font-size: 36px; }
.fs37 { font-size: 37px; }
.fs38 { font-size: 38px; }
.fs39 { font-size: 39px; }
.fs40 { font-size: 40px; }
.br1 { border-radius: 1px; }
.br2 { border-radius: 2px; }
.br3 { border-radius: 3px; }
.br4 { border-radius: 4px; }
.br5 { border-radius: 5px; }
.br6 { border-radius: 6px; }
.br7 { border-radius: 7px; }
.br8 { border-radius: 8px; }
.br9 { border-radius: 9px; }
.br1 { border-radius: 1px; }
.br2 { border-radius: 2px; }
.br3 { border-radius: 3px; }
.br4 { border-radius: 4px; }
.br5 { border-radius: 5px; }
.br6 { border-radius: 6px; }
.br7 { border-radius: 7px; }
.br8 { border-radius: 8px; }
.br9 { border-radius: 9px; }
.br10 { border-radius: 10px; }
.br11 { border-radius: 11px; }
.br12 { border-radius: 12px; }
.br13 { border-radius: 13px; }
.br14 { border-radius: 14px; }
.br15 { border-radius: 15px; }
.br16 { border-radius: 16px; }
.br17 { border-radius: 17px; }
.br18 { border-radius: 18px; }
.br19 { border-radius: 19px; }
.br20 { border-radius: 20px; }
.br21 { border-radius: 21px; }
.br22 { border-radius: 22px; }
.br23 { border-radius: 23px; }
.br24 { border-radius: 24px; }
.br25 { border-radius: 25px; }
.br26 { border-radius: 26px; }
.br27 { border-radius: 27px; }
.br28 { border-radius: 28px; }
.br29 { border-radius: 29px; }
.br30 { border-radius: 30px; }
.br31 { border-radius: 31px; }
.br32 { border-radius: 32px; }
.br33 { border-radius: 33px; }
.br34 { border-radius: 34px; }
.br35 { border-radius: 35px; }
.br36 { border-radius: 36px; }
.br37 { border-radius: 37px; }
.br38 { border-radius: 38px; }
.br39 { border-radius: 39px; }
.br40 { border-radius: 40px; }
.mg1 { margin: 1px; }
.mg2 { margin: 2px; }
.mg3 { margin: 3px; }
.mg4 { margin: 4px; }
.mg5 { margin: 5px; }
.mg6 { margin: 6px; }
.mg7 { margin: 7px; }
.mg8 { margin: 8px; }
.mg9 { margin: 9px; }
.mg10 { margin: 10px; }
.mg15 { margin: 15px; }
.mg20 { margin: 20px; }
.mg25 { margin: 25px; }
.mg30 { margin: 30px; }
.a5 { opacity: 0.05; }
.a10 { opacity: 0.1; }
.a15 { opacity: 0.15; }
.a20 { opacity: 0.2; }
.a25 { opacity: 0.25; }
.a30 { opacity: 0.3; }
.a35 { opacity: 0.35; }
.a40 { opacity: 0.4; }
.a45 { opacity: 0.45; }
.a50 { opacity: 0.5; }
.a55 { opacity: 0.55; }
.a60 { opacity: 0.6; }
.a65 { opacity: 0.65; }
.a70 { opacity: 0.7; }
.a75 { opacity: 0.75; }
.a80 { opacity: 0.8; }
.a85 { opacity: 0.85; }
.a90 { opacity: 0.9; }
.a95 { opacity: 0.95; }
.bold { font-weight: bold; }
.w100 { width: 100%; }
.h100 { height: 100%; }
.flex-width { flex: 1; width: 0; }
.flex-height { flex: 1; height: 0; }
.flex { display: flex; }
.flex-reverse { display: flex; flex-direction: row-reverse; }
.flex-column { display: flex; flex-direction: column; }
.items-center { align-items: center; }
.content-center { justify-content: center; }
.flex-1 { flex: 1; } 
.relative { position: relative; }
.absolute { position: absolute; }
.overflow-hidden { overflow: hidden; }
.scroll {overflow: auto;}
.scroll::-webkit-scrollbar{
	display: none;
}
.text-center { text-align: center; }
.cursor-pointer { cursor: pointer; }
.bg-white { background: white; }
.one-line {
	word-break: break-all;
	text-overflow: ellipsis;
	display: -webkit-box;
	-webkit-box-orient: vertical;
	overflow: hidden;
	-webkit-line-clamp: 1;
}	
.two-line {
	word-break: break-all;
	text-overflow: ellipsis;
	display: -webkit-box;
	-webkit-box-orient: vertical;
	overflow: hidden;
	-webkit-line-clamp: 2;
}
</style>


<style lang="less">
.my-dialog {
    border-radius: 10px;
    .el-dialog__header {
        padding: 0;
    }
    .el-dialog__body {
        padding-top: 10px!important;
    }
}
</style>